module.exports = __webpack_public_path__ + "img/part-2-title.4adba5d1.png";